<template>
  <table class="order-list-table">
    <thead>
      <tr>
        <th v-for="item in list_head" :key="item.id" :class="item.class">{{ item.title }}</th>
      </tr>
    </thead>
    <tbody :id="tbody_id" @scroll="commit_scroll_top">
      <template v-for="item in list">
        <tr :key="item.id" :class="{'unsubscribe': item.deleted_date !== ''}">
          <td class="td-id">{{ item.id }}</td>
          <td class="td-date" v-html="date_br(item.order_date)"></td>
          <td class="td-name">
            <div @click="user_detail_disp(item.customer_id)">
              <span v-if="item.deleted_date !== ''">[退会]</span>
              <span>{{ item.customer_name }}</span>
            </div>
          </td>
          <td class="td-status">
            <div :class="{'twice-div' : item.status == 4, 'other-div' : item.status == 1 || item.status == 2 || item.status == 3 || item.status == 5}">
              <div
                v-if="item.status == 1 || item.status == 2 || item.status == 5"
                v-bind:class="{'status-button-selected-order': item.status == 1}"
                @click="status_change(item, 1)"
                class="status-button"
              >注文</div>
              <div
                v-if="item.status == 1 || item.status == 2 || item.status == 3"
                v-bind:class="{'status-button-selected-accept': item.status == 2}"
                @click="status_change(item, 2)"
                class="status-button"
              >受付済み</div>
              <div
                v-if="item.status == 2 || item.status == 3 || item.status == 4"
                v-bind:class="{'status-button-selected-product': item.status == 3}"
                @click="status_change(item, 3)"
                class="status-button"
              >製造中</div>
              <div
                v-if="item.status == 3 || item.status == 4"
                v-bind:class="{'status-button-selected-shipping': item.status == 4}"
                @click="status_change(item, 4)"
                class="status-button"
              >発送済み</div>
              <div
                v-if="item.status == 1 || item.status == 5"
                v-bind:class="{'status-button-selected-cancel': item.status == 5}"
                @click="status_change(item, 5)"
                class="status-button"
              >ｷｬﾝｾﾙ</div>
            </div>
          </td>
          <td class="td-detail">
            <div v-if="item.status == 4" class="item-info-box address-box">
              <p class="title">発送日</p>
              <p class="content">{{ item.updated_date }}</p>
            </div>
            <div class="item-info-box address-box">
              <p class="title">お届け先</p>
              <p class="content">{{ item.name }}</p>
              <p class="content zip-code">〒{{ item.zip_code }}</p>
              <p class="content">{{ item.prefecture }}{{ item.address1 }}{{ item.address2 }}</p>
            </div>
            <template v-for="order in item.orders">
              <div class="item-box" :key="order.id">
                <div class="item-info-box kind-box">
                  <p class="title">種類</p>
                  <div class="kind-info-box">
                    <div>
                      <p class="content" v-for="order_item in order.items" :key="order_item.id">{{ order_item.name }}</p>
                    </div>
                    <div>
                      <div v-if="item.status == 3" @click="order_item_status_chg(order)" class="order-status" v-bind:class="{'order-status-fin': order.status == 1}">完了</div>
                    </div>
                  </div>
                </div>
                <div class="item-info-box type-box">
                  <p class="title">焙煎</p>
                  <p class="content">{{ type_name[order.type] }}</p>
                </div>
                <div class="item-info-box weight-box">
                  <p class="title">量</p>
                  <p class="content">{{ order.weight }} g</p>
                </div>
                <div class="item-info-box num-box">
                  <p class="title">個数</p>
                  <p class="content">{{ order.num }}</p>
                </div>
              </div>
            </template>
            <div class="item-info-box price-box">
              <p class="title">価格</p>
              <p class="content">{{ yen_separate(item.price) }} 円 (税 {{ yen_separate(item.tax) }} 円、送料 {{ yen_separate(item.post_price) }} 円)</p>
            </div>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>

export default {
  created () {
    this.tbody_id = 'order_list_tbody' + this.tab_id;
  },
  data () {
    return {
      tbody_id: '',
      list_head: [
        {id: 1, title: '注文ID', class: 'th-id'},
        {id: 2, title: '注文日', class: 'th-date'},
        {id: 3, title: '会員名', class: 'th-name'},
        {id: 4, title: 'ステータス', class: 'th-status'},
        {id: 5, title: '詳細', class: 'th-detail'}
      ],
      type_name: {1: '浅煎り', 2: '中煎り', 3: '深煎り'},
    };
  },
  computed: {
  },
  props: {
    tab_id: Number,
    list: Array,
    cb_f: null,
  },
  methods: {
    status_change (list_item, status) {
      const my = this;
      if(list_item.status != status) {
        if (list_item.status === 3 && status === 4) {
          // 全て完了になっているかチェック
          let i;
          let len = list_item.orders.length;
          for (i = 0; i < len; i++) {
            if (list_item.orders[i].status === 0) {
              this.$alert('alert', '詳細のステータスがすべて「完了」になっていないため、「発送済み」に変更できません。');
              return;
            }
          }
          this.$alert('alert', '「発送済み」にステータスを変更すると、発送済みのメールを会員に送信します。\n「発送済み」に変更してよろしいですか？',
            function() { my.status_change_start(list_item, status); });
        } else if (list_item.status === 4 && status === 3) {
          this.$alert('alert', '「製造中」から「発送済み」にもう一度変更した場合、発送済みのメールを会員に送信します。\n「製造中」に変更してよろしいですか？',
            function() { my.status_change_start(list_item, status); });
        } else if (status === 5) {
          this.$alert('alert', '「キャンセル」に変更してよろしいですか？',
            function() { my.status_change_start(list_item, status); });
        } else {
          this.status_change_start(list_item, status);
        }
      }
    },
    status_change_start (list_item, status) {
      let ld = new this.$loader(this);
      ld._m_data_set({token: this.$store.getters['mLoginInfo/login_token'],
        order_id: list_item.id,
        status: status});
      ld._post_cb_f = this.status_change_cb(list_item, status);
      ld._load_start('manage/order_status_chg.php');
    },
    status_change_cb (list_item, status) {
      const my = this;
      return function (data) {
        if (data.res === 1) {
          list_item.status = status;
          if (my.cb_f !== null && my.cb_f !== undefined) {
            my.cb_f();
          }
        } else if (data.res === 6) {
          my.$alert('alert', '詳細のステータスがすべて「完了」になっていないため、「発送済み」に変更できません。');
          if (my.cb_f !== null && my.cb_f !== undefined) {
            my.cb_f();
          }
        } else {
          my.$alert('alert', 'ステータスの変更に失敗しました。');
        }
      };
    },
    order_item_status_chg (order_item) {
      let set_status = 0;
      if (order_item.status === 0) {
        set_status = 1;
      }
      let ld = new this.$loader(this);
      ld._m_data_set({token: this.$store.getters['mLoginInfo/login_token'],
        blend_item_id: order_item.id,
        status: set_status});
      ld._post_cb_f = this.order_item_status_chg_cb(order_item, set_status);
      ld._load_start('manage/blend_item_status_chg.php');
    },
    order_item_status_chg_cb (order_item, set_status) {
      const my = this;
      return function (data) {
        if (data.res === 1) {
          order_item.status = set_status;
          if (my.cb_f !== null && my.cb_f !== undefined) {
            my.cb_f();
          }
        } else {
          my.$alert('alert', '完了の変更に失敗しました。');
        }
      };
    },
    user_detail_disp (customer_id) {
      this.$router.push({ name: 'mCustomerDetail', params: { id: String(customer_id), type: 2 }});
    },
    commit_scroll_top (event) {
      // スクロール位置保存
      this.$store.commit('mOrderList/set_table_scroll_top' + String(this.tab_id), Math.floor(event.target.scrollTop));
    },
    date_br (date_str) {
      return date_str.replace(' ', '<br>');
    },
    yen_separate (num) {
      return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
  },
  updated () {
    let sc_top = this.$store.getters['mOrderList/table_scroll_top' + String(this.tab_id)];
    document.getElementById(this.tbody_id).scrollTop = sc_top;
  },
};
</script>

<style lang="scss">
table.order-list-table {
  margin: 0 auto;
  box-sizing: border-box;
  thead {
    display:block;
    tr {
      background-color: $manage-table-head-bg-color;
    }
    th {
      border: 1px solid $manage-table-border-color;
      border-bottom: none;
      padding: 5px 0;
      box-sizing: border-box;
    }
    th.th-id {
      width: 80px;
    }
    th.th-name {
      width: 180px;
      padding: 0 10px;
    }
    th.th-date {
      width: 140px;
    }
    th.th-status {
      width: 270px;
    }
    th.th-detail {
      width: 417px;
    }
  }
  tbody{
    display:block;
    overflow-y:scroll;
    height: calc(100vh - 280px);
    min-height: 320px;
    width: 1105px;
    tr.unsubscribe {
      background-color: #efefef;
    }
    td {
      border: 1px solid $manage-table-border-color;
      box-sizing: border-box;
    }
    td.td-id {
      width: 80px;
    }
    td.td-name {
      width: 180px;
      text-align: left;
      padding: 0 10px;
      div {
        cursor: pointer;
        color: #9c5360;
        text-decoration: underline;
        width: fit-content;
      }
      div:hover {
        color: #e91f42;
      }
    }
    td.td-date {
      width: 140px;
    }
    td.td-status {
      width: 270px;
      div.twice-div {
        margin: 0 auto;
        width: 180px;
      }
      div.other-div {
        margin: 0 auto;
        width: 270px;
        max-width: 270px;
      }
      div.status-button {
        float: left;
        border: 1px solid;
        margin: 10px 5px;
        border: 1px solid #fffff3;
        border-radius: 5px;
        width: 80px;
        height: 30px;
        line-height: 30px;
        background-color: #DDD;
        color: #FFF;
        box-sizing: border-box;
        cursor: pointer;
      }
      div.status-button-selected-order {
        background-color: #107ca0;
        cursor: default;
      }
      div.status-button-selected-accept {
        background-color: #bb130c;
        cursor: default;
      }
      div.status-button-selected-product {
        background-color: #14a55c;
        cursor: default;
      }
      div.status-button-selected-shipping {
        background-color: #bb870f;
        cursor: default;
      }
      div.status-button-selected-cancel {
        background-color: #666666;
        cursor: default;
      }
      div.status-button:not(.status-button-selected-order):not(.status-button-selected-accept):not(.status-button-selected-product):not(.status-button-selected-shipping):not(.status-button-selected-cancel):hover {
        background-color: #738f53;
      }
    }
    td.td-detail {
      width: 417px;
      .item-box {
        display: flex;
        border-bottom: 1px solid $manage-table-border-color;
        .item-info-box {
          text-align: left;
          padding: 0 5px;
          box-sizing: border-box;
          border-right: 1px solid $manage-table-border-color;
          .title {
            color: #080808;
            margin-top: 3px;
            font-size: 0.7rem;
            font-weight: bold;
          }
          .content {
            margin-left: 5px;
            font-size: 0.9rem;
          }
        }
        .item-info-box:last-child {
          border-right: none;
        }
        .kind-box {
          width: 200px;
          line-height: 1.5;
          .kind-info-box {
            display: flex;
            justify-content: space-between;
            .order-status {
              width: 30px;
              height: 24px;
              line-height: 24px;
              color: #FFF;
              background-color: #ddd;
              padding: 0 7px;
              margin: 5px 0;
              border-radius: 5px;
              text-align: center;
              font-size: 0.9rem;
              border: 2px solid transparent;
              cursor: pointer;
            }
            .order-status:hover {
              border-color: #738f53;
            }
            .order-status-fin {
              background-color: #588f1a;
            }
          }
        }
        .type-box {
          width: 90px;
          .content {
            text-align: center;
          }
        }
        .weight-box {
          width: 60px;
          .content {
            text-align: center;
          }
        }
        .num-box {
          width: 50px;
          .content {
            text-align: center;
          }
        }
      }
      .price-box {
        background-color: $manage-table-bg-sub-color;
        line-height: 1.5;
        .title {
          color: #080808;
          font-size: 0.7rem;
          font-weight: bold;
        }
      }
      .address-box {
        line-height: 1.5;
        text-align: left;
        padding: 0 5px;
        box-sizing: border-box;
        border-bottom: 1px solid $manage-table-border-color;
        .title {
          color: #080808;
          margin-top: 3px;
          font-size: 0.7rem;
          font-weight: bold;
        }
        .content.zip-code {
          font-size: 0.8rem;
        }
      }
    }
  }
}
</style>
